import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Skeleton } from "@mui/material";
import Typography from "@mui/material/Typography";
import { DeliveryScheduleRemappingText } from "../utils/DSRM-typesAndEnums";
export const DSRM_Explainer = ({ orderNumber, orderData, altText }) => {
    const blockingCopy = altText ? altText : orderData.blockingCopy;
    return (_jsxs(Box, { children: [orderNumber && (_jsx(Typography, Object.assign({ variant: "h4", color: "primary", gutterBottom: true }, { children: `${DeliveryScheduleRemappingText.ORDER_NUMBER} ${orderNumber}` }))), orderData.loading ? (_jsx(Skeleton, Object.assign({ variant: "text" }, { children: _jsx(Typography, { children: DeliveryScheduleRemappingText.REMAPPING_BLOCKING_COPY }) }))) : (_jsx(Typography, { children: blockingCopy }))] }));
};
